import { render } from "./KRHPPaigutus.vue?vue&type=template&id=452cf7f6&ts=true"
import script from "./KRHPPaigutus.vue?vue&type=script&lang=ts"
export * from "./KRHPPaigutus.vue?vue&type=script&lang=ts"

import "./KRHPPaigutus.vue?vue&type=style&index=0&id=452cf7f6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__